"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPatchedEditor = void 0;
var slate_1 = require("slate");
var lodash_1 = require("lodash");
var createPatchedEditor = function () {
    var editor = (0, slate_1.createEditor)();
    editor.normalizeNode = patchedNormalizeNode.bind(null, editor);
    return editor;
};
exports.createPatchedEditor = createPatchedEditor;
var patchedNormalizeNode = function (editor, entry) {
    var _a = __read(entry, 2), node = _a[0], path = _a[1];
    if (slate_1.Text.isText(node)) {
        return;
    }
    if (slate_1.Element.isElement(node) && node.children.length === 0) {
        var child = { text: "" };
        slate_1.Transforms.insertNodes(editor, child, {
            at: path.concat(0),
            voids: true,
        });
        return;
    }
    var shouldHaveInlines = slate_1.Editor.isEditor(node)
        ? false
        : slate_1.Element.isElement(node) &&
            (editor.isInline(node) ||
                node.children.length === 0 ||
                slate_1.Text.isText(node.children[0]) ||
                editor.isInline(node.children[0]));
    var n = 0;
    for (var i = 0; i < node.children.length; i++, n++) {
        var currentNode = slate_1.Node.get(editor, path);
        if (slate_1.Text.isText(currentNode))
            continue;
        var child = node.children[i];
        var prev = currentNode.children[n - 1];
        var isLast = i === node.children.length - 1;
        var isInlineOrText = slate_1.Text.isText(child) || (slate_1.Element.isElement(child) && editor.isInline(child));
        if (isInlineOrText !== shouldHaveInlines) {
            slate_1.Transforms.removeNodes(editor, { at: path.concat(n), voids: true });
            n--;
        }
        else if (slate_1.Element.isElement(child)) {
            if (editor.isInline(child)) {
                if (prev == null || !slate_1.Text.isText(prev)) {
                    var newChild = { text: "" };
                    slate_1.Transforms.insertNodes(editor, newChild, {
                        at: path.concat(n),
                        voids: true,
                    });
                    n++;
                }
                else if (isLast) {
                    var newChild = { text: "" };
                    slate_1.Transforms.insertNodes(editor, newChild, {
                        at: path.concat(n + 1),
                        voids: true,
                    });
                    n++;
                }
            }
        }
        else {
            if (prev != null && slate_1.Text.isText(prev)) {
                if ((0, lodash_1.isEqual)((0, lodash_1.omit)(child, "text"), (0, lodash_1.omit)(prev, "text"))) {
                    slate_1.Transforms.mergeNodes(editor, { at: path.concat(n), voids: true });
                    n--;
                }
                else if (prev.text === "") {
                    slate_1.Transforms.removeNodes(editor, {
                        at: path.concat(n - 1),
                        voids: true,
                    });
                    n--;
                }
                else if (isLast && child.text === "") {
                    slate_1.Transforms.removeNodes(editor, {
                        at: path.concat(n),
                        voids: true,
                    });
                    n--;
                }
            }
        }
    }
};
